module.exports = __webpack_public_path__ + "static/img/zhonglitankuang.1890acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhonglitankuang.png
// module id = 7vgG
// module chunks = 44